// Refresh a Turbo Frame that polls one URL.
//
// Assigning a frame the src it already has doesn't fetch anything, so the frame has to be
// reloaded explicitly. A frame's `src` reads back as the raw attribute, which for a Rails path
// helper is root-relative, so both sides are resolved against the base URI before comparing —
// otherwise every poll after the first takes the assignment branch and silently does nothing.
export function pollFrame(frame, url, baseURI) {
  if (!frame) return "skipped"

  const currentSrc = frame.getAttribute("src")
  if (currentSrc && new URL(currentSrc, baseURI).href === new URL(url, baseURI).href) {
    frame.reload()
    return "reloaded"
  }

  frame.src = url
  return "assigned"
}
